var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/report-batch-history.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2bb685b2!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/report-batch-history.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ReportBatchHistory.vue
// module id = 346
// module chunks = 1